<mat-card class="container-card mat-elevation-z8">
    <app-search-bar [filterFields]="['name']" [filterMap]="{ name: ['name'] }" [filterLabels]="{ name: ['Field'] }" (filtersChanged)="onFilterChanged($event)">
    </app-search-bar>

    <app-shared-table [dataSource]="metaDataSource" [displayedColumns]="['name', 'type', 'actions']" [columnLabels]="{ name: 'Field', type: 'Tipologia' }" [length]="totalItems" [pageSize]="pageSize" [pageIndex]="pageIndex" (pageChanged)="onPageChanged($event)"
        (sortChanged)="onSortChanged($event)" (openModal)="openDialog($event)" [isLoading]="isLoading" [hasError]="hasError">
    </app-shared-table>

    <app-loading [showLoading]="showFullScreenLoading"></app-loading>
</mat-card>